import { customElement, autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { IValidatedElement, IError } from '@aurelia-mdc-web/base';
import { CurrenciesCache } from '../../services/currencies-cache';
import { CurrencyCodeViewModel } from '@dynamik/common/clients/transaction-clients';

@autoinject
@customElement('currency-lookup')
export class CurrencyLookup {
  constructor(public root: Element, private currenciesCache: CurrenciesCache) {
    defineCurrencyLookupElementApis(this.root as HTMLElement);
  }

  input: HTMLInputElement & { isFocused: boolean };

  @bindable({ defaultBindingMode: bindingMode.twoWay })
  value: string;

  @bindable.booleanAttr
  readonly: boolean;

  @bindable.booleanAttr
  disabled: boolean;

  @bindable.booleanAttr
  allowClear: boolean;

  @bindable
  label: string = 'Search currency';

  @bindable
  infoTitle: string;

  optionsFunction = async (filter: string, value: string): Promise<CurrencyCodeViewModel[]> => {
    const currencies = await this.currenciesCache.get();
    if (value) {
      return Promise.resolve(currencies.filter(x => x.name === value));
    } else {
      if (filter) {
        return Promise.resolve(currencies.filter(x => x.name.toLowerCase().startsWith(filter.toLowerCase())));
      }
      return Promise.resolve(currencies);
    }
  };

  addError(error: IError) {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'addError')) {
      (this.input as HTMLElement as IValidatedElement).addError(error);
    }
  }

  removeError(error: IError) {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'addError')) {
      (this.input as HTMLElement as IValidatedElement).removeError(error);
    }
  }

  renderErrors() {
    if (this.input && Object.getOwnPropertyDescriptor(this.input, 'renderErrors')) {
      (this.input as HTMLElement as IValidatedElement).renderErrors();
    }
  }

  clear() {
    this.value = undefined;
  }
}

export interface ICurrencyLookupElement extends IValidatedElement {
  au: {
    controller: {
      viewModel: CurrencyLookup;
    };
  };
}

function defineCurrencyLookupElementApis(element: HTMLElement) {
  Object.defineProperties(element, {
    addError: {
      value(this: ICurrencyLookupElement, error: IError) {
        this.au.controller.viewModel.addError(error);
      },
      configurable: true
    },
    removeError: {
      value(this: ICurrencyLookupElement, error: IError) {
        this.au.controller.viewModel.removeError(error);
      },
      configurable: true
    },
    renderErrors: {
      value(this: ICurrencyLookupElement): void {
        this.au.controller.viewModel.renderErrors();
      },
      configurable: true
    },
  });
}

